// extracted by mini-css-extract-plugin
export default {"grid":"UserGroupGridOtherPrivileges_grid__uoS6O","tabContent":"UserGroupGridOtherPrivileges_tabContent__Aa-3S"};